import config from '../../config'
import session from './session'
import dialog from './dialog'
import loading from './loading'
import date from './date'
import util from './util'
import request from './request'
const sys = {
	config:config,
	session:session,
	dialog:dialog,
    loading:loading,
	date:date,
	util:util,
	request:request
 }
 export default sys
   


// WEBPACK FOOTER //
// ./src/common/js/sys.js